import * as React from "react"
import { Row, Col, Container } from "shards-react"

import _ from "lodash"
import SocialMediaNavigation from "./socialMediaNavigation"
import ContactTray from "./contactTray"
import NavigationList from "./navigationList"
import NavigationLink from "./navigationLink"

const UpperFooter = props => (
  <div className="bg-light">
    <Container>
      <br />
      <Row>
        <Col xs={12} sm={12} md={6}>
          <br />
          <h5>Our Mission</h5>

          <br />
          <p>
            The CSG Learning Institute is a private institution
            {props.country.name
              ? _.concat(" in ", props.country.name + " ")
              : " "}
            dedicated to modernizing Caribbean education and fostering a new and
            improved alternative to the current educational standard.
          </p>

          <SocialMediaNavigation />
          <ContactTray
            email={props.country.email}
            phone_one={props.country.phone_one}
            phone_two={props.country.phone_two}
          />
          <br />
        </Col>
        <Col xs={12} sm={12} md={3}>
          <br />
          <h5>Programs</h5>
          <NavigationList>
            <NavigationLink
              dark
              title="SAT Program"
              countryCode={props.country.countryCode}
              href={props.routes.sat}
            />
            <NavigationLink
              dark
              title="Diplomas in Spanish"
              countryCode={props.country.countryCode}
              href={props.routes.dele}
            />
            <NavigationLink
              dark
              title="Diplomas in French"
              countryCode={props.country.countryCode}
              href={props.routes.delf}
            />
            <NavigationLink
              dark
              title="Online CSEC Classes"
              countryCode={props.country.countryCode}
              href={props.routes.csec}
            />
            <NavigationLink
              dark
              title="Online CAPE Classes"
              countryCode={props.country.countryCode}
              href={props.routes.cape}
            />
          </NavigationList>
          <br />
        </Col>
        <Col xs={12} sm={12} md={3}>
          <br />
          <h5>Quick Links</h5>
          <NavigationList>
            <NavigationLink
              dark
              external
              title="Store"
              countryCode={props.country.countryCode}
              href={props.routes.store}
            />
            <NavigationLink
              dark
              external
              title="Our Apps"
              countryCode={props.country.countryCode}
              href={props.routes.apps}
            />
            <NavigationLink
              dark
              external
              title="Student Portal"
              countryCode={props.country.countryCode}
              href={props.routes.portal}
            />
            <NavigationLink
              dark
              title="Make a Payment"
              countryCode={props.country.countryCode}
              href={props.routes.pay}
            />
            <NavigationLink
              dark
              title="Join the Team"
              countryCode={props.country.countryCode}
              href={props.routes.careers}
            />
          </NavigationList>
        </Col>
      </Row>
      <br />
      <br />
    </Container>
  </div>
)

export default UpperFooter
